<template>
    <b-container class="pt-3" fluid>
        Line登入
    </b-container>
</template>

<script>
    export default {
        name: 'LineAuthorize',
        data() {
          return {
            apiLineAuthorize: (data) => this.userRequest.post("/API/Default/LineAuthorize", data),
          }
        },
        components: {
        },
        updated(){
        },
        mounted(){

            this.checkLineLogin();
    
        },  
        methods:{

            //取得網址 Get 參數
            getSearchParams(key){

                var url = new URL(location.href);
                return url.searchParams.get(key);
            },

            //確認是否由 Line 那邊導向過來的
            checkLineLogin(){

                let state = this.getSearchParams("state");

                //備註:如果使用者在 [要求存取的項目] 點選 [許可] 會回傳
                //?code=mtruVeSQXetDxfAYH6QR&state=login
                let code = this.getSearchParams("code");

                //備註:如果使用者在 [要求存取的項目] 點選 [取消] 會回傳
                //?error=ACCESS_DENIED&state=login&error_description=The+resource+owner+denied+the+request.

                let error = this.getSearchParams("error");
                let error_description = this.getSearchParams("error_description");

                console.log(state);
                console.log(code);
                console.log(error);
                console.log(error_description);

                if(error == "ACCESS_DENIED"){

                    alert("您好，必須允許雲林農業平台Line的權限，才能使用Line功能");         
                    //備註:因為 IOS Safari 瀏覽器不支援 location.href，故改成 window.location
                    //location.href = './Login';
                    window.location = './Login';
                    return false;
                }

                if(code != null && state!= null)
                {
                    /* 測試OK - 帳號驗證(如果Line_User_ID 有則直接登入，如果沒有則建立新帳號後再登入) */     
                    this.getLineAuthorize({
                        code:code,
                        state:state,
                    });

                }
            },

            //取得 Line 身分驗證
            getLineAuthorize(data){

                this.apiLineAuthorize(data)
                .then((res)=>{
                    const json = JSON.parse(res.data)
 
                    let UserInfo = json.mAgriUserInfo;

                    let AC_ID = UserInfo.AC_ID;
                    let AC_USERID = UserInfo.AC_USERID;
                    let AC_USERNAME = UserInfo.AC_USERNAME;
                    let AC_PWD = UserInfo.AC_PWD;
                    let AC_USERTYPE = UserInfo.AC_USERTYPE;
                    let AC_STATUS = UserInfo.AC_STATUS;
                    let AC_GROUP_ID = UserInfo.AC_GROUP_ID;
                    let AC_TITLE = UserInfo.AC_TITLE;
                    let AC_TEL_EX = UserInfo.AC_TEL_EX;
                    let AC_KEYID = UserInfo.AC_KEYID;
                    let AC_SEX = UserInfo.AC_SEX;
                    let AC_IDNUM = UserInfo.AC_IDNUM;
                    let AC_BIRTHDAY = UserInfo.AC_BIRTHDAY;
                    let AC_CONTACT = UserInfo.AC_CONTACT;
                    let AC_POST = UserInfo.AC_POST;
                    let AC_CITYID = UserInfo.AC_CITYID;
                    let AC_TOWNID = UserInfo.AC_TOWNID;
                    let AC_ADDRESS = UserInfo.AC_ADDRESS;
                    let AC_TEL = UserInfo.AC_TEL;
                    let AC_MOBILE = UserInfo.AC_MOBILE;
                    let AC_FAX = UserInfo.AC_FAX;
                    let AC_EMAIL = UserInfo.AC_EMAIL;
                    let AC_CONTENT = UserInfo.AC_CONTENT;
                    let AC_IMG = UserInfo.AC_IMG;
                    let AC_ORDER = UserInfo.AC_ORDER;
                    let AC_VCOUNT = UserInfo.AC_VCOUNT;
                    let AC_MDATE = UserInfo.AC_MDATE;
                    let AC_EDATE = UserInfo.AC_EDATE;
                    let AC_EUSER = UserInfo.AC_EUSER;
                    let AC_LOGINSET = UserInfo.AC_LOGINSET;
                    let AC_ISDEL = UserInfo.AC_ISDEL;
                    let AC_NOTIFY = UserInfo.AC_NOTIFY;
                    let AC_ERROR_TIME = UserInfo.AC_ERROR_TIME;
                    let AC_ERROR_COUNT = UserInfo.AC_ERROR_COUNT;
                    let AC_LINE_USER_ID = UserInfo.AC_LINE_USER_ID;

                    let UserName = UserInfo.UserName;
                    let TokenID = UserInfo.TokenID;
                    let DisposableLine = UserInfo.DisposableLine;

                    console.log(AC_ID);
                    console.log(AC_USERID);
                    console.log(AC_USERNAME);
                    console.log(AC_PWD);
                    console.log(AC_USERTYPE);
                    console.log(AC_STATUS);
                    console.log(AC_GROUP_ID);
                    console.log(AC_TITLE);
                    console.log(AC_TEL_EX);
                    console.log(AC_KEYID);
                    console.log(AC_SEX);
                    console.log(AC_IDNUM);
                    console.log(AC_BIRTHDAY);
                    console.log(AC_CONTACT);
                    console.log(AC_POST);
                    console.log(AC_CITYID);
                    console.log(AC_TOWNID);
                    console.log(AC_ADDRESS);
                    console.log(AC_TEL);
                    console.log(AC_MOBILE);
                    console.log(AC_FAX);
                    console.log(AC_EMAIL);
                    console.log(AC_CONTENT);
                    console.log(AC_IMG);
                    console.log(AC_ORDER);
                    console.log(AC_VCOUNT);
                    console.log(AC_MDATE);
                    console.log(AC_EDATE);
                    console.log(AC_EUSER);
                    console.log(AC_LOGINSET);
                    console.log(AC_ISDEL);
                    console.log(AC_NOTIFY);
                    console.log(AC_ERROR_TIME);
                    console.log(AC_ERROR_COUNT);
                    console.log(AC_LINE_USER_ID);

                    console.log(UserName);
                    console.log(TokenID);
                    console.log(DisposableLine);

                    sessionStorage.setItem("TokenID", TokenID);
                    sessionStorage.setItem("username", UserName);

                    if(Number(DisposableLine) == 1){

                        sessionStorage.setItem("disposable_line", "1");
                    }

                    this.$router.push({ path: "/" });
                    window.location.reload();
                })
                .catch((err)=> {
                    console.log(err)
                });   
            },
        }
    }
</script>